// src/locales.js
export const messages = {
    US: {
      welcome: "Welcome",
      hello: "Hello, {name}!",
      Immuniser:"Immunizer",
      Immunization: "Immunization",
      optimised: "optimized",
      locum: "pharmacist",
      pharmacyProfessional: "pharmacy professional",
      miles: "miles",
      Categorize: "Categorize",
      Categorized: "Categorized",
      employer: "Employer",
      BusinessAddress: "Business Address",
    },
    AU: {
      welcome: "G'day",
      hello: "G'day, {name}!",
      Immuniser:"Immuniser",
      Immunization: "Immunisation",
      optimised: "optimised",
      locum: "pharmacist",
      pharmacyProfessional: "pharmacy professional",
      miles: 'KM',
      Categorize: "Categorise",
      Categorized: "Categorised",
      employer: "Employer",
      BusinessAddress: "Location",
    }
  };
  